<template>
    <div class="col-xs-12" :class="{'banner-only': bannerOnly}">
        <div class="challenge-of-the-week-container">
            <div class="image-container" :style="getBackgroundImageStyle()" @click="bannerClickHandler">
                <div class="more-about" style="display: none"><span style="z-index: 3; display: none;">Mehr erfahren <i class="dev-external-link"></i></span>
                </div>
                <img class="hidden-xs hidden-sm hidden-md challenge-of-the-week-image clickable"
                     :src="activeImage.desktop">
                <img class="visible-xs visible-sm visible-md challenge-of-the-week-image clickable"
                     :src="activeImage.mobile">
            </div>
            <a class="company-logo-wrapper" :href="challengeOfTheWeek.companyProfileLink" v-if="showLogo">
                <img class="company-logo"
                     :src="challengeOfTheWeek.companyLogo">
            </a>
            <div class="challenge-of-the-week-heading" v-if="!bannerOnly"><span
                class="">Challenge der Woche<br/></span>
                <div class="challenge-title">
                    {{ challengeOfTheWeek.title }}
                </div>
                <div class="challenge-language">
                    <LanguageBubble :technology-list="challengeOfTheWeek.languages"
                                    :hasAction="false"></LanguageBubble>
                </div>
            </div>
            <div class="challenge-of-the-week-cta" v-if="!bannerOnly">
                <router-link :to="{ name: 'challenge-details', params: { slug: challengeOfTheWeek.challengeSlug }}"
                             class="btn btn-big-cta btn-challenge-of-the-week">
                    <span class="hidden-xs hidden-sm hidden-md"></span><i class="dev-play">&nbsp;</i>mitmachen
                    <span class="hidden-sm hidden-md">und lösen</span>
                </router-link>
                <a :href="challengeOfTheWeek.linkOfSponsor" v-if="winnablePrice" class="winnable-image-container">
                    <img class="winnable-image hidden-xs"
                                                  src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1669902657/eh-platform/company.platform.entwicklerheld.de/profiles/yz17rdyhn2nl7h8duyzc.png">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import LanguageBubble from "./LanguageBubble";
import {mapState} from "vuex";

export default {
    name: "ChallengeOfTheWeek",
    components: {
        LanguageBubble,
    },
    props: {
        userProfileRequest: {
            type: Object,
            required: true,
        },
        bannerOnly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        images: function () {
            return [
                    {
                    desktop: "https://company.platform.entwicklerheld.de/link/zoll-sept-2025-073-2000x500",
                    mobile: "https://company.platform.entwicklerheld.de/link/zoll-sept-2025-073-900x400",
                    background: "",
                    backgroundColor: "#000",
                },
            ];
        },
        ...mapState([
            'isAuthenticated'
        ]),
    },
    data() {
        return {
            winnablePrice: true,
            showLogo: false,
            challengeOfTheWeek: {
                title: "Water Jugs",
                languages: [{id: 1, language: '', name: ''}],
                companyLogo: "https://res.cloudinary.com/dspi5zyaa/image/upload/v1669902657/eh-platform/company.platform.entwicklerheld.de/profiles/yz17rdyhn2nl7h8duyzc.png",
                companyProfileLink: "https://platform.entwicklerheld.de/company/zoll-karriere",
                challengeSlug: "water-jugs",
                linkOfSponsor: "https://company.platform.entwicklerheld.de/link/zoll-sept-2025-073-link",
            },
            activeImage: {},
        }
    },
    created() {
        this.activeImage = this.getRandomImage();

    },
    methods: {
        bannerClickHandler: function () {
            // This is only needed when the banner leads to another page than the challenge
            window.open(this.challengeOfTheWeek.linkOfSponsor, '_blank');
            this.$router.push({name: 'challenge-details', params: {slug: this.challengeOfTheWeek.challengeSlug}});
        },
        getRandomImage: function () {
            return this.images[Math.floor(Math.random() * this.images.length)];
        },
        getBackgroundImageStyle: function () {
            return {
                "background-image": `url("${this.activeImage.background}")`,
                "background-color": this.activeImage.backgroundColor,
            }
        },
    },
}
</script>

<style scoped>
.banner-only {
    margin-bottom: 4rem;
    margin-top: -2rem;
    padding-left: 1rem;
    padding-right: 1rem;
}

@media (max-width: 769px) {
    .banner-only {
        margin-bottom: 2rem;
        margin-top: 2rem;
        padding-left: 0;
        padding-right: 0;
    }
}

.challenge-of-the-week-container {
    position: relative;
    display: inline-block;
    z-index: 2;
    overflow: hidden;
    width: 100%;
    background: black;
}

@media (max-width: 769px) {
    .challenge-of-the-week-container {
      /*border-radius: 10px;*/
    }
}

.clickable {
    transition: transform 0.5s;
}

.image-container:hover .more-about {
    text-decoration: underline;
    cursor: pointer;
}

.image-container:hover .clickable {
    cursor: pointer;
    -moz-transform: scale(1.02);
    -webkit-transform: scale(1.02);
    -o-transform: scale(1.02);
    -ms-transform: scale(1.02);
    transform: scale(1.02);

}

.image-container {
    background-size: cover;
    animation: moving-background 180s linear;
    animation-iteration-count: infinite;
}

@keyframes moving-background {
    0% {
        background-position: 0% 0%;
    }
    100% {
        background-position: 0% 200%;
    }
}

@media (max-width: 769px) {
    .image-container {
        background: #252525;
    }
}

.more-about {
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 1rem;
    color: white;
    text-align: right;
    text-transform: uppercase;
    text-shadow: 0 0 10px black;
}

.banner-cta {
    position: absolute;
    z-index: 100;
    color: white;
    /* center absolute */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.challenge-of-the-week-image {
    display: block;
    width: 100%;
    max-height: 500px;
    object-fit: contain;
    padding-bottom: 95px;
}

.challenge-of-the-week-container::after {
    content: "";
    position: absolute;
    pointer-events: none;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(to left, rgba(0, 0, 0, .8) 0%, rgba(0, 0, 0, 0) 20%);
}

.company-logo-wrapper {
    position: absolute;
    left: 3rem;
    top: 5rem;
    z-index: 3;
    transition: all 0.3s ease-in-out;
}

.company-logo-wrapper:hover {
    transform: scale(1.05);
    transition: all 0.3s ease-in-out;
}

.company-logo {
    max-width: 400px;
    max-height: 50px;
}

.challenge-of-the-week-heading {
    position: absolute;
    bottom: 5rem;
    left: 3rem;
    z-index: 3;
    color: white;
    font-size: 1.6rem;
}

.challenge-title {
    color: white;
    font-size: 3.5rem;
    font-weight: 600;
}

.challenge-language {
    margin-top: 1rem;
}

.winnable-image {
    -max-width: 250px;
    width: 100%;
    margin-bottom: 1rem;
}

/*
    .challenge-of-the-week-cta {
      position: absolute;
      right: 3rem;
      top: 50%;
      transform: translateY(-50%);
      z-index: 3;
      width: 23%;
      text-align: center;
    }

 */

.btn-challenge-of-the-week {
    max-width: 500px;
    width: 100%;
    padding: 1rem 3rem;
    font-size: 2rem;
    text-transform: uppercase;
    color: white;
    border: none;
    vertical-align: middle;
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    -webkit-transition-property: color;
    transition-property: color;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    z-index: 1;
}

.btn-challenge-of-the-week:hover {
    color: white;
}

@media (min-width: 1200px) and (max-width: 1400px) {
    .challenge-of-the-week-heading {
        bottom: 1.5rem;
    }

    .company-logo-wrapper {
        top: 2.5rem;
    }
}

.challenge-of-the-week-heading {
    height: 100px;
    bottom: 0;
    width: 100%;
    padding: 1.3rem;
    padding-left: 2rem;
    left: 0;
    backdrop-filter: blur(5px) invert(0.13);
}

.challenge-of-the-week-cta {
    bottom: 0;
    position: absolute;
    transform: initial;
    right: 0;
    width: 54%;
    height: 100px;
    z-index: 3;
    text-align: right;
}

.winnable-image {
    height: 100px;
    width: auto;
    max-width: 150px;
    display: inline-block;
    margin: 0;
}

.challenge-language {
    display: inline-block;
    transform: scale(75%);
}

.challenge-title {
    display: inline-block;
}

.challenge-group-languages-wrapper >>> .challenge-group-languages {
    font-size: 10px !important;
}

.btn.btn-big-cta.btn-challenge-of-the-week {
    width: initial;
    margin-right: 4rem;
}

.winnable-image-container {
    display: inline-block;
}

@media (max-width: 1400px) {

    .company-logo {
        max-width: 300px;
    }

    .btn-challenge-of-the-week {
        font-size: 1.5rem;
    }


}

@media screen and (max-width: 767px) {
    .btn.btn-big-cta.btn-challenge-of-the-week {
        margin-top: 3rem;
    }

    .challenge-of-the-week-image {
        margin-bottom: 65px;
        padding-bottom: 0;
    }

    .challenge-title {
        font-size: 2.8rem;
    }

}

@media screen and (max-width: 713px) {
    .challenge-of-the-week-cta {
        width: 100%;
        text-align: center;
        height: 60px;
    }

    .btn.btn-big-cta.btn-challenge-of-the-week {
        margin-right: 0;
        margin-top: 0;
    }

    .challenge-of-the-week-image {
        margin-bottom: 160px;
    }

    .banner-only .challenge-of-the-week-image {
        margin-bottom: 0;
    }

    .challenge-of-the-week-heading {
        height: 160px;
        text-align: center;
    }

    .challenge-language {
        display: none;
    }

}

.btn.btn-big-cta.btn-challenge-of-the-week::before {
    background: #cdcdce !important;
    left: 0px;
    border-radius: 7px;
}

.btn.btn-big-cta.btn-challenge-of-the-week {
    color: black;
    background: linear-gradient(110.16deg, #e2e8e8 3.84%, whitesmoke 93.74%) !important;
}

.winnable-image-container {
    background-color: whitesmoke;
}
</style>